import { render, staticRenderFns } from "./FooterPhone.vue?vue&type=template&id=7c1b32b6&scoped=true&"
import script from "./FooterPhone.vue?vue&type=script&lang=js&"
export * from "./FooterPhone.vue?vue&type=script&lang=js&"
import style0 from "./FooterPhone.vue?vue&type=style&index=0&id=7c1b32b6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b32b6",
  null
  
)

export default component.exports